import { DebitRecordsPanel } from "@/components/organisms";

export const DebitRecords = () => {
  return (
    <div className="mb-12 flex flex-1 flex-col">
      <DebitRecordsPanel />
    </div>
  );
};
